import { Button } from '@/ui';

interface Props {
  dataTest: string;
  message: string;
  actionLabel: string;
  actionDataTest: string;
  onAction: () => void;
  actionDisabled?: boolean;
}

export default function MobileAppFrameAlert({
  dataTest,
  message,
  actionLabel,
  actionDataTest,
  onAction,
  actionDisabled = false,
}: Props) {
  return (
    <div
      role='alert'
      data-test={dataTest}
      className='absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 bg-slate-900/90 px-4 text-center'
    >
      <p className='text-sm text-white'>{message}</p>
      <Button
        variant='secondary'
        onClick={onAction}
        disabled={actionDisabled}
        data-test={actionDataTest}
        className='bg-white text-slate-900 hover:enabled:bg-white/90'
      >
        {actionLabel}
      </Button>
    </div>
  );
}
